import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { Grid, Button, Box, Typography, TextField } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Autocomplete from '@mui/material/Autocomplete';
import { ToastContainer, toast } from 'react-toastify';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import InfoIcon from '@mui/icons-material/Info';

const LoadingOverlay = ({ loading }) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'rgba(0, 0, 0, 0.8)', // Dark translucent background
      }}
      open={loading}
    >
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress
          color="secondary"
          size={62}
          thickness={4}
          sx={{ mb: 2 }} // Add some spacing below the spinner
        />
        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
            color: '#ffeb3b', // Bright yellow text
            animation: 'fade 2s infinite',
          }}
        >
          Loading, please wait...
        </Typography>
      </Box>
      <style>
        {`
              @keyframes fade {
                  0%, 100% { opacity: 1; }
                  50% { opacity: 0.5; }
              }
              `}
      </style>
    </Backdrop>
  );
};

const MySwal = withReactContent(Swal);

const showDuplicateEntryAlert = (title, message) => {
  MySwal.fire({
    title: <strong>{title}</strong>,
    html: <div dangerouslySetInnerHTML={{ __html: message }} />,
    icon: 'error',
    confirmButtonColor: '#1976d2',
    confirmButtonText: 'OK',
  });
};

function PackingEntry(props) {
  const navigate = useNavigate();
  const [EntryNo, setEntryNo] = useState(0);
  const [TrDate, setTrDate] = useState(getCurrentDate());
  const [FinishedItCode, setFinishedItCode] = useState(0);
  const [PerQty, setPerQty] = useState(0.0);
  const [PerWeight, setPerWeight] = useState(0.0);
  const [Rate, setRate] = useState(0);
  const [Amount, setAmount] = useState(0);
  const [ProdPlanNo, setProdPlanNo] = useState(0);
  const [BatchNo, setBatchNo] = useState(0);
  const [FormPerQty, setFormPerQty] = useState(0);
  const [EmpCode, setEmpCode] = useState('');
  const [Narration, setNarration] = useState('');
  const [bal, setBal] = useState(0);
  const [loading, setLoading] = useState(false);

  const [opbal, setOpbal] = useState(0);
  const [balance, setBalance] = useState(0);
  const [balances, setBalances] = useState({});
  const [lastBalance, setLastBalance] = useState(0);
  const [ShortQty, setShortQty] = useState(0.0);
  const [Loss, setLoss] = useState(0.0);
  const [Depouching, setDepouching] = useState(0.0);

  const [rows, setRows] = useState([{ RawItCode: 0, Qty: 0.0, OpBal: 0, Weight: 0, Rate1: 0, Amount1: 0 }]);
  const [DeptCode, setDeptCode] = useState('');
  const [UserID, setUserID] = useState('');
  const [units, setUnits] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const location = useLocation();
  const flag = new URLSearchParams(location.search).get('flag');
  const title = new URLSearchParams(location.search).get('title');

  const [filteredRows, setFilteredRows] = useState([]);

  const [deleteEntryNo, setDeleteEntryNo] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [formMode, setFormMode] = useState('edit');
  const [editCasteId, setEditCasteCode] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [ProductMasterEntries, setProductMasterEntries] = useState([]);
  const [ProductFormulaMaster, setProductFormulaMaster] = useState([]);
  const [ProductPlanEntries, setProductPlanEntries] = useState([]);
  const [EmployeeMasterEntries, setEmployeeMasterEntries] = useState([]);
  const [packingMasterEntries, setPackingMasterEntries] = useState([]);
  const [settingMasterEntries, setSettingMasterEntries] = useState([]);
  const [itemMasterEntries, setItemMasterEntries] = useState([]);

  useEffect(() => {
    fetchProductMaster();
    fetchItemMaster();
    fetchSettingMaster();
    fetchProductPlan();
    fetchProductFormula();
    fetchEmpMaster();
    fetchReportData2();
    fetchPackingMaster();
  }, []);

  const handlePerQtyChange = (e) => {
    setPerQty(e.target.value);
  };

  const handlePerWeightChange = (e) => {
    const value = parseFloat(e.target.value);

    if (isNaN(value)) return;

    if (bal <= 0) {   // ✅ check if balance is zero
        toast.error('Cannot enter Total Weight. Balance is 0.', { autoClose: 1500 });
        setPerWeight(''); // reset input
        return;
    }

    if (value <= 0) {
      toast.error('Total Weight must be greater than 0', { autoClose: 1000 });
      setPerWeight('');
      return;
    }

    setPerWeight(value);
    // Valid input
  };

  const fetchProductMaster = async () => {
    try {
      const response = await axios.get(`https://www.wingap.net.in/api/processentry/${flag}/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`);
      setProductMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1;
      setEntryNo(nextEntryNo);
      //console.log(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const calculateMaxEntryNo = (entries) => {
    let maxEntryNo = 0;
    for (const entry of entries) {
      if (entry.EntryNo > maxEntryNo) {
        maxEntryNo = entry.EntryNo;
      }
    }
    return maxEntryNo;
  };

  const fetchProductPlan = async () => {
    try {
      const response = await axios.get(`https://www.wingap.net.in/api/processentry/PRODPL/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`);
      setProductPlanEntries(response.data);
      //console.log(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchSettingMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/setting');
      setSettingMasterEntries(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const isStockCheckEnabled = settingMasterEntries?.some(
    (s) =>
      s.SettingDesc1?.toLowerCase() === 'stockcheck' &&
      s.SettingValue1?.toLowerCase() === 'y'
  );

  const fetchEmpMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/employee');
      setEmployeeMasterEntries(response.data.sort((a, b) => a.EmpCode - b.EmpCode));
      //console.log(response)
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchPackingMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/packing');
      setPackingMasterEntries(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchProductFormula = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/prodForm');
      setProductFormulaMaster(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchItemMaster = async () => {
    try {
      const response = await axios.get("https://www.wingap.net.in/api/items-master");
      let data = response.data.filter(el => [2, 3, 4, 5].includes(el.ItemSubGroupCode));
      setItemMasterEntries(data.sort((a, b) => a.ItCode - b.ItCode));
    } catch (error) {
      console.log("error:", error);
    }
  };

  function getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleBatchQty = async (date, itcode) => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/batchQty', {
        params: {
          startDate: date,
          ItCode: parseInt(itcode),
          CompCode: props.selectedCompany
        }
      });

      const filteredData = response.data.filter(item => item.ItCode == parseInt(itcode));
      //console.log("filtered Data",filteredData);
      setFilteredRows(filteredData);
    } catch (error) {
      console.error('Error fetching balances:', error);
    }
  };

  const handleEditBatchQty = async (trdate, entryno, itcode) => {
    try {
      const params = {
        TrDate: trdate,
        EntryNo: parseInt(entryno),
      };

      if (itcode) {
        params.ItCode = parseInt(itcode);
      }

      const response = await axios.get(`https://www.wingap.net.in/api/subProcessEntry/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`, {
        params: params
      });

      if (itcode) {
        const filteredData = response.data.filter(item => item.ItCode === parseInt(itcode));
        setFilteredRows(filteredData);
      } else {
        //console.log(response.data);
        setFilteredRows(response.data);
      }
    } catch (error) {
      console.error('Error fetching balances:', error);
    }
  };

  const addProduct = async () => {
    if (!props.canAdd) {
      const action = "Save";
      toast.error(`You do not have permission to ${action}.`, { autoClose: 780 });
      return;
    }
    try {
      const totalWeight = rows.reduce((total, row) => total + (parseFloat(row.Weight) || 0), 0);
      //const totalWeight = rows.reduce((total, row) => total + (parseFloat(row.Weight) || 0), 0) + (parseFloat(ShortQty) || 0) + (parseFloat(Depouching) || 0) + (parseFloat(Loss) || 0);;

      if (parseFloat(PerWeight) !== totalWeight) {
        let mismatchMessage = '';
        if (parseFloat(PerWeight) !== totalWeight) {
          mismatchMessage += `Weight (${parseFloat(PerWeight)}) and TotalWeight (${totalWeight}) must be equal.<br>`;
        }

        showDuplicateEntryAlert(
          'Weight Mismatch',
          mismatchMessage
        );
        return;
      }

      const productData = {
        Flag: flag,
        EntryNo: Number(EntryNo),
        TrDate: TrDate,
        FinishedItCode: Number(FinishedItCode),
        PerQty: Number(PerWeight),
        PerWeight: Number(PerWeight),
        ShortQty: Number(ShortQty),
        Loss: Number(Loss),
        Depouching: Number(Depouching),
        Rate: Rate,
        Amount: Amount,
        BatchNo: BatchNo,
        Narration,
        EmpCode: EmpCode,
        HeatNo: 6,
        UserID: props.name,
        items: rows,
      };

      await axios.post(`https://www.wingap.net.in/api/packEntry/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`, productData);
      toast.success('Entry Added Successfully....', { autoClose: 650 });
      setPerQty(0.0);
      setPerWeight(0.0);
      setShortQty(0.0);
      setNarration('');
      setFinishedItCode(0);
      setTrDate(getCurrentDate());
      setRate('');
      setAmount('');
      setProdPlanNo(0);
      setEmpCode('');
      setBatchNo('');
      setLoss('');
      setDepouching('');
      setRows([{ RawItCode: 0, Qty: 0.0, OpBal: 0, Weight: 0, Rate1: 0, Amount1: 0 }]);
      fetchProductMaster();
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateProduct = async () => {
    if (!props.canEdit) {
      const action = "Update";
      toast.error(`You do not have permission to ${action}.`, { autoClose: 780 });
      return;
    }
    try {
      //const totalWeight = rows.reduce((total, row) => total + (parseFloat(row.Weight) || 0), 0);
      const totalWeight = rows.reduce((total, row) => total + (parseFloat(row.Weight) || 0), 0) + (parseFloat(ShortQty) || 0) + (parseFloat(Depouching) || 0) + (parseFloat(Loss) || 0);;

      if (parseFloat(PerWeight) !== totalWeight) {
        let mismatchMessage = '';

        if (parseFloat(PerWeight) !== totalWeight) {
          mismatchMessage += `Weight (${parseFloat(PerWeight)}) and TotalWeight (${totalWeight}) must be equal.<br>`;
        }

        showDuplicateEntryAlert(
          'Weight Mismatch',
          mismatchMessage
        );
        return;
      }

      const updatedProductData = {
        TrDate: TrDate,
        FinishedItCode: Number(FinishedItCode),
        PerQty: Number(PerWeight),
        PerWeight: Number(PerWeight),
        ShortQty: Number(ShortQty),
        Loss: Number(Loss),
        Depouching: Number(Depouching),
        Rate: Rate,
        Amount: Amount,
        BatchNo: BatchNo,
        Narration,
        EmpCode: EmpCode,
        UserID: props.name,
        HeatNo: 6,
        items: rows,
      };
      await axios.put(`https://www.wingap.net.in/api/packEntry/${flag}/${EntryNo}/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`, updatedProductData);
      toast.success('Entry Updated Successfully....', { autoClose: 650 });
      setFormMode('add');
      setPerQty(0.0);
      setPerWeight(0.0);
      setShortQty(0.0);
      setNarration('');
      setFinishedItCode(0);
      setTrDate(getCurrentDate());
      setRate('');
      setAmount('');
      setProdPlanNo(0);
      setEmpCode('');
      setBatchNo('');
      setLoss('');
      setDepouching('');
      setRows([{ RawItCode: 0, Qty: 0.0, OpBal: 0, Weight: 0, Rate1: 0, Amount1: 0 }]);
      fetchProductMaster();
    } catch (error) {
      console.log('Error updating product:', error);
    }
  };

  const handleDeleteConfirmation = async () => {
    try {
      if (deleteEntryNo) {
        await deleteProduct(deleteEntryNo.entryNo, deleteEntryNo.flag);
        setOpenConfirmation(false);
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteProduct = async (EntryNo, flag) => {
    if (!props.canDelete) {
      toast.error("You do not have permission to Delete.", { autoClose: 800 });
      return;
    }
    try {
      await axios.delete(`https://www.wingap.net.in/api/distinctprocess/${EntryNo}/${flag}/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`, {
        headers: {
          'username': props.name,
        },
      });
      fetchProductMaster();
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const setEditForm = (room) => {
    setFormMode('edit');
    setEntryNo(room.EntryNo);
    const formattedDate = new Date(room.TrDate).toISOString().split("T")[0];
    setTrDate(formattedDate);
    setFinishedItCode(room.ItCode);
    setPerQty(room.PerQty);
    setPerWeight(room.WeightPer);
    setNarration(room.Remark1);
    setShortQty(room.ShortQty);
    setBatchNo(room.BatchNo);
    setRate(room.Rate);
    setAmount(room.Amount);
    setEmpCode(room.EmpCode);
    setLoss(room.Loss);
    setDepouching(room.Depouch);
    setUserID(room.UserID);
    const finishedEntry = ProductFormulaMaster.find(entry => entry.FinishedItCode == room.ItCode);
    if (finishedEntry) {
      setFormPerQty(finishedEntry.PerQty);
    } else {
      setFormPerQty(0);
    }

    const filteredEntries = ProductMasterEntries.filter(entry => entry.EntryNo === room.EntryNo);

    const newRows = filteredEntries.map(filteredEntry => {
      const item = itemMasterEntries.find(item => item.ItCode === filteredEntry.RawItCode);
      return {
        RawItCode: item ? item.ItCode : 0,
        Qty: filteredEntry.Qty,
        Weight: filteredEntry.Weight,
        Rate1: filteredEntry.Rate1,
        Amount1: filteredEntry.Amount1
      };
    });

    setRows(newRows);
    setShowGrid(false);
  };

  const handleSaveProduct = async () => {
    if (formMode === 'add') {
      await addProduct();
    } else if (formMode === 'edit') {
      await updateProduct();
    }
  };

  const handleFinishedItCodeChange = async (newValue) => {
    setFormMode('add');
    if (newValue) {
      setFinishedItCode(newValue.ItCode);
      //console.log(newValue, getCurrentDate());
      if (newValue.ItCode) {
        const lastBalance = newValue ? await fetchReportData2(getCurrentDate(), getCurrentDate(), newValue.ItCode) : 0;
        setBal(lastBalance);
        //console.log("Fetched lastBalance for FinishedItCode:", lastBalance);
      } else {
        setBal(0);
      }
      setFormPerQty(0);
      fetchProductMaster();
    } else {
      setFinishedItCode('');
      setBal(0);
      setFormPerQty(0);
      setRows([]);
      fetchProductMaster();
    }
  };

  const handleExitButtonClick = () => {
    navigate('/Dashboard');
  };

  const handleshowandhide = () => {
    setFormMode('add');
    setShowGrid(!showGrid);
    setUnits(units);
    setFinishedItCode('');
    setPerQty('');
    setPerWeight('');
    setNarration('');
    setTrDate(getCurrentDate());
    setBatchNo('');
    setEmpCode('');
    setProdPlanNo(0);
    setRows([{ RawItCode: 0, Qty: 0.0, OpBal: 0, Weight: 0, Rate1: 0, Amount1: 0 }]);
    fetchProductMaster();
  };

  const handleCancel = () => {
    setFormMode('add');
    setEditCasteCode('');
    setPerQty('');
    setNarration('');
    setFormPerQty('');
    setRate('');
    setAmount('');
    setBatchNo('');
    setProdPlanNo('');
    setEmpCode('');
    setRows([{ RawItCode: 0, Qty: 0.0, OpBal: 0, Weight: 0, Rate1: 0, Amount1: 0 }]);
    setUserID('');
    fetchProductMaster();
  };

  const handleClearTemp = async () => {
    try {
      handleCancel();
      handleshowandhide();
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "Caste Data",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }

        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  /* const handleRowChange = (index, field, value) => {
    const updatedRows = rows.map((row, i) => {
      if (i === index) {
        return { ...row, [field]: field === 'RawItCode' || field === 'Qty' ? Number(value) : value };
      }
      return row;
    });
    setRows(updatedRows);
  }; */

  const handleRowChange = (index, field, value) => {
    const updatedRows = rows.map((row, i) => {
      if (i === index) {
        let updatedRow = { ...row, [field]: field === 'RawItCode' || field === 'Qty' ? Number(value) : value };

        if (field === 'Qty') {
          const selectedItem = itemMasterEntries.find((item) => item.ItCode == row.RawItCode);
          if (selectedItem) {
            const packingEntry = packingMasterEntries.find(
              (packing) => packing.PackingCode == selectedItem.PackingCode
            );
            if (packingEntry) {
              const conversionFactor = packingEntry.ConversionFactor || 0;
              updatedRow.Weight = (conversionFactor * parseFloat(value || 0)).toFixed(2);
            }
          }
        }

        if (field === 'Weight') {
          const selectedItem = itemMasterEntries.find((item) => item.ItCode == row.RawItCode);
          if (selectedItem) {
            const packingEntry = packingMasterEntries.find(
              (packing) => packing.PackingCode == selectedItem.PackingCode
            );
            if (packingEntry) {
              const conversionFactor = packingEntry.ConversionFactor || 0;
              updatedRow.Qty = conversionFactor > 0 ? (parseFloat(value || 0) / conversionFactor).toFixed(2) : 0;
            }
          }
        }
        return updatedRow;
      }
      return row;
    });
    setRows(updatedRows);
  };


  const addRow = () => {
    setRows([...rows, { RawItCode: 0, Qty: 0.0, OpBal: 0, Weight: 0, Rate1: 0, Amount1: 0 }]);
  };

  const removeRow = (index) => {
    const newRows = rows.filter((_, i) => i !== index);
    setRows(newRows);
  };

  /* const fetchReportData2 = async (formattedDate1, currentDate, itCode) => {
    try {
      if (!formattedDate1 || !currentDate || itCode === undefined || isNaN(itCode)) {
        console.warn("Invalid parameters:", { formattedDate1, currentDate, itCode });
        return;
      }
      const requestData = {
        startDate: formattedDate1,
        endDate: currentDate,
        itemCode: itCode,
        CompCode: props.selectedCompany,
      };
      setLoading(true);
      const opBalFromReport = (await handleStockReport(formattedDate1, itCode)) || 0;
      console.log('Opening Balance:', opBalFromReport);

      const response = await axios.get(`https://www.wingap.net.in/api/stockLedgerr`, { params: requestData });
      console.log('Original Data:', response.data);

      if (response.data.length === 0) {
        setOpbal('');
        setBalance('');
        return opBalFromReport;
      }

      let opbal = opBalFromReport;
      let lastCurrentBalance = opbal;

      const data = response.data
        .sort((a, b) => {
          const dateA = new Date(a.Trdate);
          const dateB = new Date(b.Trdate);

          if (dateA < dateB) return -1;
          if (dateA > dateB) return 1;

          if (a.EntryNo < b.EntryNo) return -1;
          if (a.EntryNo > b.EntryNo) return 1;

          return 0;
        })
        .map((rowData) => {
          const InQty = rowData.InQty || 0;
          const OutQty = rowData.OutQty || 0;

          const currentBalance = opbal + InQty - OutQty;
          lastCurrentBalance = currentBalance;
          opbal = currentBalance;

          return {
            ...rowData,
            BalQty: `${currentBalance}`,
          };
        });

      //console.log(data);

      if (data.length > 0) {
        setOpbal(data[data.length - 1].Balance || '');
        setBalance(data[data.length - 1].BalQty || '');
      } else {
        setOpbal('');
        setBalance('');
      }

      setLastBalance(lastCurrentBalance);
      return lastCurrentBalance;
    } catch (error) {
      console.error('Error in fetchReportData2:', error);
      return 0;
    } finally {
      setLoading(false); // Stop loading
    }
  };
 */

  const fetchReportData2 = async (formattedDate1, currentDate, itCode) => {
    //console.log(formattedDate1, currentDate, itCode);
    if (!formattedDate1 || !currentDate || !itCode) {
      console.error('Missing required parameters:', { formattedDate1, currentDate, itCode });
      return;
    }
    setLoading(true);

    try {
      const requestData = {
        startDate: formattedDate1,
        endDate: currentDate,
        itemCode: itCode,
        CompCode: props.selectedCompany,
      };

      // Fetch opening balance
      const opBalFromReport = await handleStockReport(formattedDate1, itCode);

      // Axios GET request with progress tracking
      const response = await axios.get(`https://www.wingap.net.in/api/stockLedgerr`, {
        params: requestData
      });
      //console.log(opBalFromReport, requestData, response.data);

      if (response.data.length === 0) {
        setOpbal('');
        setBalance('');
        return opBalFromReport;
      }

      let opbal = 0;
      const data = response.data.map((rowData) => {
        const InQty = rowData.InQty || 0;
        const OutQty = rowData.OutQty || 0;

        opbal += InQty - OutQty;
        return { ...rowData, BalQty: opbal };
      });

      return opbal;
    } catch (error) {
      console.error('Error fetching report data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleStockReport = async (date, itcode) => {
    setLoading(true);
    try {
      if (!date || itcode === undefined || isNaN(itcode)) {
        console.warn("Invalid parameters:", { date, itcode });
        return;
      }
      const response = await axios.get('https://www.wingap.net.in/api/stockkReport', {
        params: {
          startDate: formatDate1(date),
          ItCode: parseInt(itcode),
          CompCode: props.selectedCompany
        }
      });

      const balanceData = response.data.filter(item => item.ItCode == parseInt(itcode))[0];
      const opBal = balanceData ? balanceData.BalQty : 0;
      //console.log(balanceData);

      const balancesByDate = { [date]: { opBal } };
      setBalances(balancesByDate);

      return opBal;
    } catch (error) {
      console.error('Error fetching balances:', error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const formatDate1 = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const totalQty = rows.reduce((total, row) => total + (parseFloat(row.Qty) || 0), 0);
  const totalWeight = rows.reduce((total, row) => total + (parseFloat(row.Weight) || 0), 0);
  const filteredItems = itemMasterEntries.filter(el => [3].includes(el.ItemSubGroupCode));

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
      <ToastContainer />
      <LoadingOverlay loading={loading} />

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
        <h1 style={{ fontSize: '24px', margin: 0 }}>
          {showGrid ? title : `${formMode === 'add' ? 'ADD' : 'EDIT'} ${title}`}
        </h1>

        <div style={{ display: 'flex' }}>
          {showGrid && (
            <Button
              variant="contained"
              onClick={generatePDF}
              sx={{ backgroundColor: "yellow", color: "black", marginLeft: "10px" }}
            >
              Download PDF
            </Button>
          )}
          {showGrid && (
            <Button
              variant="contained"
              sx={{ backgroundColor: "yellow", color: "black", marginLeft: "10px" }}
            >
              Export
            </Button>
          )}
          <Grid item>
            {showGrid && (<Button
              variant="contained"
              onClick={handleExitButtonClick}
              sx={{ backgroundColor: "red", color: "white", marginLeft: '10px' }}
            >
              Exit
            </Button>)}
            {(props.canAdd === true) && (<Button
              variant="contained"
              className="view-button"
              onClick={handleshowandhide}
              sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginLeft: '10px' }}
            >
              {showGrid ? 'Add' : 'Back'}
            </Button>)}
          </Grid>
        </div>
      </div>

      {!showGrid && (
        <>
          <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '4px' }}>
            <>
              <div style={{ maxWidth: '100%' }}>
                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px', backgroundColor: '#DEDADA', borderRadius: '5px', color: '#333', padding: '5px', width: '100%' }}>

                  {/* <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '0px', width: '100%' }}> */}
                  <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '1px', width: '100%' }}>

                    {(flag === 'PACK') && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                      <label htmlFor="EntryNo">EntryNo</label>
                      <input
                        type="number"
                        value={EntryNo}
                        placeholder="EntryNo"
                        readOnly
                        style={{ padding: '5px', width: '72px' }}
                      />
                    </div>}

                    {(flag === 'PACK') && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '6px' }}>
                      <label htmlFor="TrDate">TrDate</label>
                      <input
                        type="date"
                        value={TrDate}
                        onChange={(e) => setTrDate(e.target.value)}
                        placeholder="TrDate"
                        style={{ padding: '5px', width: '108px' }}
                      />
                    </div>}

                    {(flag === 'PACK') && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '6px' }}>
                      <label htmlFor="FinishedItCode">Finished Item (Loose)</label>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
                        <TextField
                          placeholder="Enter ItCode"
                          value={FinishedItCode || ''}
                          onChange={(e) => {
                            const newCode = e.target.value;
                            setFinishedItCode(newCode);

                            const matchedItem = itemMasterEntries.find(item => item.ItCode == newCode);
                            if (matchedItem) {
                              handleFinishedItCodeChange(matchedItem); // Update with the full item object
                            }
                          }}
                          sx={{
                            marginBottom: '5px',
                            marginRight: '4px',
                            width: '72px',
                            '& .MuiInputBase-input': {
                              color: 'black',
                              padding: '6px',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'black',
                            },
                            backgroundColor: 'white'
                          }}
                        />
                        <Autocomplete
                          //options={itemMasterEntries}
                          //getOptionLabel={(option) => option.ItName || ''}
                          //value={itemMasterEntries.find((item) => item.ItCode == FinishedItCode) || null}
                          //onChange={(event, newValue) => handleFinishedItCodeChange(newValue)}


                          options={itemMasterEntries}
                          getOptionLabel={(option) => option.PartNo ? `${option.PartNo} - ${option.ItName}` : option.ItName}
                          value={itemMasterEntries.find((item) => item.ItCode == FinishedItCode) || null}
                          onChange={(event, newValue) => handleFinishedItCodeChange(newValue)}
                          filterOptions={(options, { inputValue }) => {
                            const lowerInput = inputValue.toLowerCase();
                            if (!lowerInput) return options; // Show all options when input is empty

                            return options.filter(
                              option =>
                                (option.PartNo && option.PartNo.toLowerCase().includes(lowerInput)) ||
                                (option.ItName && option.ItName.toLowerCase().includes(lowerInput))
                            );
                          }}
                          renderOption={(props, option) => (
                            <li {...props} style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ textAlign: 'left' }}>{option.PartNo}</span>
                              <span style={{ textAlign: 'right', fontWeight: 600 }}>{option.ItName}</span>
                            </li>
                          )}

                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="FinishedItCode"
                              sx={{
                                marginBottom: '5px',
                                width: '272px',
                                '& .MuiInputBase-input': {
                                  color: 'black',
                                  padding: '1px',
                                  height: '1px'
                                },
                                '& .MuiInputLabel-root': {
                                  color: 'black',
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                  borderColor: 'black',
                                },
                                '& .MuiSvgIcon-root': {
                                  color: 'black',
                                },
                                backgroundColor: 'white'
                              }}
                            />
                          )}
                          sx={{ width: '272px' }}
                          isOptionEqualToValue={(option, value) => option.ItCode === value.ItCode}
                        />
                        {/* <InfoIcon
                          style={{ cursor: 'pointer', color: '#007BFF', fontSize: '22px' }}
                          onClick={async () => {
                            if (!FinishedItCode) {
                              toast.warning('FinishedItCode is empty', { autoClose: 760 });
                              return;
                            }
                                await handleBatchQty(getCurrentDate(), FinishedItCode);
                            
                              if (TrDate && EntryNo) {
                                await handleEditBatchQty(TrDate, EntryNo, FinishedItCode);
                              } else {
                                console.log('TrDate or EntryNo is missing', { autoClose: 760 });
                              }
                          }}
                        /> */}
                      </div>
                    </div>}

                    {/* {(flag === 'PACK') && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '2px' }}>
                      <label htmlFor="FinishedItName">FinishedItName</label>
                      
                      <Autocomplete
                        options={itemMasterEntries.filter((group) => group.ItName).map((group) => group.ItName)}
                        getOptionLabel={(option) => option.ItName || ''}
                        value={itemMasterEntries.find((item) => item.ItCode == FinishedItCode) || null}
                        onChange={(event, newValue) => handleFinishedItCodeChange(newValue)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder="FinishedItCode"
                            sx={{
                              marginBottom: '5px',
                              width: '272px',
                              '& .MuiInputBase-input': {
                                color: 'black',
                                padding: '1px',
                                height: '1px'
                              },
                              '& .MuiInputLabel-root': {
                                color: 'black',
                              },
                              '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: 'black',
                              },
                              '& .MuiSvgIcon-root': {
                                color: 'black',
                              },
                              backgroundColor: 'white'
                            }}
                          />
                        )}
                        sx={{ width: '272px' }}
                        isOptionEqualToValue={(option, value) => option.ItCode === value.ItCode}
                      />
                    </div>} */}

                    {(flag === 'PACK') && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '6px' }}>
                      <label htmlFor="Balance">Balance(Wt)</label>
                      <input
                        type="number"
                        value={bal}
                        readOnly
                        placeholder="Balance"
                        style={{ padding: '5px', width: '90px', backgroundColor: '#4caf50', textAlign: 'right', fontWeight: 'bold' }}
                      />
                    </div>}

                    {/* {(flag === 'PACK' || flag === 'PRODPL') && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '10px' }}>
                      <label htmlFor="FormPerQty">{flag === 'PACK' ? 'ProdPlan PerQty' : 'Formula PerQty'}</label>
                      <input
                        type="number"
                        value={FormPerQty}
                        readOnly
                        placeholder="Formula PerQty"
                        style={{ padding: '5px', width: '100px', backgroundColor: 'darkkhaki', fontWeight: 'bold' }}
                      />
                    </div>} */}

                    {/* {(flag === 'PACK') && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '6px' }}>
                      <label htmlFor="PerQty">Total Qty</label>
                      <input
                        type="number"
                        value={PerQty}
                        onChange={handlePerQtyChange}
                        placeholder="TotalQty"
                        style={{ padding: '5px', width: '80px', textAlign: 'right' }}
                      />
                    </div>} */}

                    {(flag === 'PACK') && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '6px' }}>
                      <label htmlFor="PerWeight">Total Weight</label>
                      <input
                        type="number"
                        value={PerWeight}
                        onChange={handlePerWeightChange}
                        placeholder="TotalWeight"
                        style={{ padding: '5px', width: '80px', textAlign: 'right' }}
                      />
                    </div>}

                    {/* {(flag === 'PACK') && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '10px' }}>
                      <label htmlFor="Rate">Rate</label>
                      <input
                        type="number"
                        value={Rate}
                        onChange={(e) => setRate(e.target.value)}
                        placeholder="Rate"
                        style={{ padding: '5px', width: '106px' }} // Adjusted width
                      />
                    </div>}

                    {(flag === 'PACK') && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '10px' }}>
                      <label htmlFor="Amount">Amount</label>
                      <input
                        type="number"
                        value={Amount}
                        onChange={(e) => setAmount(e.target.value)}
                        placeholder="Amount"
                        style={{ padding: '5px', width: '106px' }}
                      />
                    </div>} */}

                    {(flag === 'PACK') && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '6px' }}>
                      <label htmlFor="Adjustment">Adjustment</label>
                      <input
                        type="number"
                        value={ShortQty}
                        onChange={(e) => setShortQty(e.target.value)}
                        placeholder="Adjustment"
                        style={{ padding: '5px', width: '80px', textAlign: 'right' }}
                      />
                    </div>}
                    {(flag === 'PACK') && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '6px' }}>
                      <label htmlFor="Loss">Loss</label>
                      <input
                        type="number"
                        value={Loss}
                        onChange={(e) => setLoss(e.target.value)}
                        placeholder="Loss"
                        style={{ padding: '5px', width: '80px', textAlign: 'right' }}
                      />
                    </div>}
                    {(flag === 'PACK') && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '6px' }}>
                      <label htmlFor="Depouching">Depouching</label>
                      <input
                        type="number"
                        value={Depouching}
                        onChange={(e) => setDepouching(e.target.value)}
                        placeholder="Depouching"
                        style={{ padding: '5px', width: '80px', textAlign: 'right' }}
                      />
                    </div>}

                    {(flag === 'PACK') && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '6px' }}>
                      <label htmlFor="BatchNo">BatchNo</label>
                      <input
                        type="text"
                        value={BatchNo}
                        onChange={(e) => setBatchNo(e.target.value)}
                        placeholder="BatchNo"
                        style={{ padding: '5px', width: '110px' }}
                      />
                    </div>}

                    {(flag === 'PACK') && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '6px', marginRight: '6px' }}>
                      <label htmlFor="EmpCode">EmpCode</label>
                      <select
                        value={EmpCode}
                        onChange={(e) => {
                          const selectedGroupName = e.target.value;
                          setEmpCode(selectedGroupName);
                          const selectedGroup = EmployeeMasterEntries.find(group => group.EmpCode == selectedGroupName);
                          if (selectedGroup) {
                            setEmpCode(selectedGroup.EmpCode);
                          }
                        }}
                        style={{ padding: '5px', width: '160px' }}
                      >
                        {EmployeeMasterEntries.map((group) => (
                          <option key={group.EmpCode} value={group.EmpCode}>{group.EmpName}</option>
                        ))}
                      </select>
                    </div>}

                    {/* <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px', width: '100%' }}> */}
                    {(flag === 'PACK') && (
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: '1', minWidth: '150px' }}>
                        <label htmlFor="Narration">Narration</label>
                        <input
                          type="text"
                          value={Narration}
                          onChange={(e) => setNarration(e.target.value)}
                          placeholder="Narration"
                          style={{
                            padding: '5px',
                            width: '40%',
                            minWidth: '120px',
                            boxSizing: 'border-box',
                          }}
                        />
                      </div>
                    )}

                  </div>
                </div>
              </div>
            </>
            <div style={{
              overflow: 'auto',
              maxHeight: '400px',
              width: '100%',
              margin: '8px auto',
              padding: '8px',
              borderRadius: '5px',
              /* backgroundColor: '#DEDADA', */
            }}>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                border: '1px solid white',
                tableLayout: 'fixed'
              }}>
                <thead style={{ backgroundColor: '#1168AA', color: 'white', position: 'sticky', top: 0, zIndex: 10 }}>
                  <tr>
                    <th style={{ width: '42px', border: '1px solid white', padding: '6px' }}>SrNo.</th>
                    {(flag === 'PACK') && <th style={{ width: '60px', border: '1px solid white', padding: '6px' }}>RawItCode</th>}
                    {(flag === 'PACK') && <th style={{ width: '250px', border: '1px solid white', padding: '6px' }}>RawItName</th>}
                    {(flag === 'PACK') && <th style={{ width: '68px', border: '1px solid white', padding: '6px' }}>Balance(Qty)</th>}
                    {(flag === 'PACK') && <th style={{ width: '120px', border: '1px solid white', padding: '6px' }}>Qty</th>}
                    {(flag === 'PACK') && <th style={{ width: '120px', border: '1px solid white', padding: '6px' }}>Weight</th>}
                    {/* {(flag === 'PACK') && <th style={{ width: '120px', border: '1px solid white', padding: '6px' }}>Rate</th>} */}
                    {/* {(flag === 'PACK') && <th style={{ width: '120px', border: '1px solid white', padding: '6px' }}>Amount</th>} */}
                    {/* {(flag === 'PACK') && <th style={{ width: '120px', border: '1px solid white', padding: '6px' }}>Actions</th>} */}
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, index) => (
                    <tr key={index}>
                      <td style={{ width: '42px', padding: '2px', border: '1px solid #333', textAlign: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '4px', width: '100%' }}>
                          <span style={{ fontSize: '0.8rem' }}>{index + 1}</span>
                          <IconButton
                            onClick={() => removeRow(index)}
                            aria-label="delete"
                            sx={{ padding: '4px' }}
                          >
                            <DeleteIcon sx={{ color: 'red', fontSize: '1.2rem' }} />
                          </IconButton>
                        </div>
                      </td>
                      {(flag === 'PACK') && (
                        <td style={{ border: '1px solid #333', padding: '2px', width: '60px' }}>
                          <TextField
                            value={row.RawItCode || ''}
                            onChange={(e) => {
                              const inputCode = e.target.value;
                              const matchedItem = itemMasterEntries.find(item => item.ItCode == inputCode);

                              const updatedRows = [...rows];
                              updatedRows[index] = {
                                ...updatedRows[index],
                                RawItCode: inputCode,
                              };

                              // If matched, update the weight & OpBal
                              if (matchedItem) {
                                const packingEntry = packingMasterEntries.find(
                                  (entry) => entry.PackingCode === matchedItem.PackingCode
                                );
                                const conversionFactor = packingEntry ? packingEntry.ConversionFactor : 1;
                                const updatedWeight = conversionFactor * (rows[index]?.Qty || 0);

                                fetchReportData2(getCurrentDate(), getCurrentDate(), matchedItem.ItCode).then((lastBalance) => {
                                  updatedRows[index].OpBal = lastBalance;
                                  updatedRows[index].Weight = updatedWeight;
                                  setRows(updatedRows);
                                });
                              } else {
                                // If not matched, clear OpBal and Weight
                                updatedRows[index].OpBal = '';
                                updatedRows[index].Weight = '';
                                setRows(updatedRows);
                              }
                            }}
                            fullWidth
                            placeholder="RawItCode"
                            sx={{
                              marginBottom: '4px',
                              '& .MuiInputBase-input': {
                                color: 'black',
                                padding: '1px',
                              },
                              '& .MuiInputLabel-root': {
                                color: 'black',
                              },
                              '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                              },
                              '& .MuiSvgIcon-root': {
                                color: 'black',
                              },
                              backgroundColor: 'white',
                            }}
                          />
                        </td>
                      )}
                      {(flag === 'PACK') && (
                        <td style={{ border: '1px solid #333', padding: '2px', width: '250px' }}>
                          <Autocomplete
                            value={filteredItems.find((item) => item.ItCode == row.RawItCode) || null}
                            options={filteredItems}
                            getOptionLabel={(option) => option.PartNo ? `${option.PartNo} - ${option.ItName}` : option.ItName}
                            //value={itemMasterEntries.find((item) => item.ItCode == FinishedItCode) || null}
                            filterOptions={(options, { inputValue }) => {
                              const lowerInput = inputValue.toLowerCase();
                              if (!lowerInput) return options; // Show all options when input is empty

                              return options.filter(
                                option =>
                                  (option.PartNo && option.PartNo.toLowerCase().includes(lowerInput)) ||
                                  (option.ItName && option.ItName.toLowerCase().includes(lowerInput))
                              );
                            }}
                            renderOption={(props, option) => (
                              <li {...props} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span style={{ textAlign: 'left' }}>{option.PartNo}</span>
                                <span style={{ textAlign: 'right' }}>{option.ItName}</span>
                              </li>
                            )}

                            onChange={async (event, newValue) => {
                              if (newValue) {
                                const selectedItCode = newValue.ItCode;
                                const selectedPackingCode = newValue.PackingCode; // Assuming PackingCode exists in itemMasterEntries

                                try {
                                  // Fetch last balance
                                  const lastBalance = await fetchReportData2(getCurrentDate(), getCurrentDate(), selectedItCode);

                                  // Find the matching PackingMasterEntry based on PackingCode
                                  const packingEntry = packingMasterEntries.find(
                                    (entry) => entry.PackingCode === selectedPackingCode
                                  );

                                  // Get the ConversionFactor from PackingMasterEntry
                                  const conversionFactor = packingEntry ? packingEntry.ConversionFactor : 1;

                                  // Calculate the Weight
                                  const updatedWeight = conversionFactor * (rows[index]?.Qty || 0);

                                  // Update the rows
                                  const updatedRows = [...rows];
                                  updatedRows[index] = {
                                    ...updatedRows[index],
                                    RawItCode: selectedItCode,
                                    OpBal: lastBalance,
                                    Weight: updatedWeight, // Set the calculated Weight
                                  };
                                  setRows(updatedRows);
                                } catch (error) {
                                  console.error('Error fetching last balance or updating weight:', error);
                                }
                              } else {
                                const updatedRows = [...rows];
                                updatedRows[index] = {
                                  ...updatedRows[index],
                                  RawItCode: '',
                                  OpBal: '',
                                  Weight: '', // Reset Weight
                                };
                                setRows(updatedRows);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                placeholder="RawItName"
                                sx={{
                                  marginBottom: '0px',
                                  width: '100%',
                                  '& .MuiInputBase-input': {
                                    color: 'black',
                                    padding: '1px',
                                    height: '1px',
                                  },
                                  '& .MuiInputLabel-root': {
                                    color: 'black',
                                  },
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                  },
                                  '& .MuiSvgIcon-root': {
                                    color: 'black',
                                  },
                                  backgroundColor: 'white',
                                }}
                              />
                            )}
                            sx={{ width: '100%' }}
                          />
                        </td>
                      )}

                      {(flag === 'PACK') && <td style={{ width: '68px', border: '1px solid #333', padding: '2px' }}>
                        <input
                          type="number"
                          value={row.OpBal}
                          placeholder="OpBal"
                          style={{ padding: '5px', border: 'none', backgroundColor: '#4caf50', fontWeight: 'bold', textAlign: 'right', width: '100%' }}
                        />
                      </td>}
                      {(flag === 'PACK') && <td style={{ width: '120px', border: '1px solid #333', padding: '2px' }}>
                        <input
                          type="number"
                          value={row.Qty}
                          onChange={(e) => handleRowChange(index, 'Qty', e.target.value)}
                          placeholder="Qty"
                          style={{ padding: '5px', border: 'none', width: '100%', textAlign: 'right' }}
                        />
                      </td>}
                      {(flag === 'PACK') && <td style={{ width: '120px', border: '1px solid #333', padding: '2px' }}>
                        <input
                          type="number"
                          value={row.Weight}
                          onChange={(e) => handleRowChange(index, 'Weight', e.target.value)}
                          placeholder="Weight"
                          style={{ padding: '5px', border: 'none', width: '100%', textAlign: 'right' }}
                        />
                      </td>}
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  {/* Total row */}
                  <tr style={{
                    position: 'sticky',
                    bottom: '30px', // reserve space for the Add Row button
                    zIndex: 10,
                    backgroundColor: '#f1f1f1'
                  }}>
                    <td colSpan={4} style={{ border: '1px solid #333', padding: '6px', textAlign: 'center' }}>
                      <strong>Total</strong>
                    </td>
                    <td style={{ border: '1px solid #333', padding: '6px', textAlign: 'right' }}>
                      <strong>{totalQty.toFixed(2)}</strong>
                    </td>
                    <td style={{ border: '1px solid #333', padding: '6px', textAlign: 'right' }}>
                      <strong>{totalWeight.toFixed(2)}</strong>
                    </td>
                  </tr>

                  {/* Add row button */}
                  <tr style={{
                    position: 'sticky',
                    bottom: 0,
                    zIndex: 11,
                  }}>
                    <td colSpan={6} style={{ textAlign: "left", padding: "2px", border: "1px solid #333" }}>
                      <button
                        onClick={addRow}
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          padding: "4px 12px",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontSize: "14px",
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        ➕ Add Row
                      </button>
                    </td>
                  </tr>
                </tfoot>

                {/* <tfoot>
                  <tr style={{
                    position: 'sticky',
                    bottom: 0,
                    zIndex: 10,
                    backgroundColor: '#f1f1f1'
                  }}>
                    <td
                      colSpan={4}
                      style={{ border: '1px solid #333', padding: '6px', textAlign: 'center' }}
                    >
                      <strong>Total</strong>
                    </td>
                    <td style={{ border: '1px solid #333', padding: '6px', textAlign: 'right' }}>
                      <strong>{totalQty.toFixed(2)}</strong>
                    </td>
                    <td style={{ border: '1px solid #333', padding: '6px', textAlign: 'right' }}>
                      <strong>{totalWeight.toFixed(2)}</strong>
                    </td>
                  </tr>
                  <tr style={{
                    position: 'sticky',
                    bottom: 0,
                    zIndex: 10,
                    backgroundColor: '#f1f1f1'
                  }}>
                      <td colSpan={6} style={{ textAlign: "left", padding: "2px", border: "1px solid #333" }}>
                        <button
                          onClick={addRow}
                          style={{
                            backgroundColor: "white",
                            color: "black",
                            padding: "4px 12px",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "14px",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          ➕ Add Row
                        </button>
                      </td>
                    </tr>
                </tfoot> */}
              </table>
            </div>
          </div>
          <div style={{ backgroundColor: '#DEDADA' }}>
            {/* <button
              type="button"
              onClick={addRow}
              style={{
                padding: '10px 20px',
                width: '100px',
                fontWeight: 'bold',
                marginTop: '10px',
                marginRight: '20px',
                marginLeft: '10px',
                backgroundColor: "#1160AA",
                color: "white",
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              Add Row
            </button> */}
            <button
              className={formMode === 'add' ? 'add-button' : 'update-button'}
              onClick={handleSaveProduct}
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                fontWeight: 'bold',
                backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginBottom: '10px',
                borderRadius: '5px'
              }}
            >
              {formMode === 'add' ? 'Save' : 'Update'}
            </button>
            <button
              className="view-button"
              onClick={handleClearTemp}
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                fontWeight: 'bold',
                backgroundColor: '#f44336',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginLeft: '10px',
                marginBottom: '10px',
                borderRadius: '5px'
              }}
            >
              Exit
            </button>
          </div>
        </>
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '6px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  SrNo.
                </th>
                <th
                  style={{
                    padding: '6px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  EntryNo
                </th>
                <th
                  style={{
                    padding: '6px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  TrDate
                </th>
                <th
                  style={{
                    padding: '6px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  FinishedItCode
                </th>
                <th
                  style={{
                    padding: '6px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  PackQty
                </th>
                <th
                  style={{
                    padding: '6px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                  className="print-hide"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {ProductMasterEntries.reduce((accumulator, current) => {
                const x = accumulator.find(item => item.EntryNo === current.EntryNo);
                if (!x) {
                  return accumulator.concat([current]);
                } else {
                  return accumulator;
                }

              }, []).sort((a, b) => {
                const dateA = new Date(a.TrDate);
                const dateB = new Date(b.TrDate);
                if (dateA > dateB) return -1;
                if (dateA < dateB) return 1;
                if (a.EntryNo > b.EntryNo) return -1;
                if (a.EntryNo < b.EntryNo) return 1;
                return 0;
              }).map((caste, index) => {
                const selectedGroup = itemMasterEntries.find(group => group.ItCode == caste.ItCode);
                return (
                  <tr key={caste.EntryNo} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                    <td style={{ padding: '6px', border: '1px solid #ccc' }}>{index + 1} </td>
                    <td style={{ padding: '6px', border: '1px solid #ccc' }}>{caste.EntryNo} </td>
                    <td style={{ padding: '8px', border: '1px solid #ccc', width: '10%' }}>{new Date(caste.TrDate).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}</td>
                    <td style={{ padding: '6px', border: '1px solid #ccc' }}>{selectedGroup ? `${selectedGroup.ItName}` : ''} </td>
                    <td style={{ padding: '6px', border: '1px solid #ccc' }}>{caste.PerQty}</td>

                    <td className="print-hide" style={{ padding: '4px', border: '1px solid #ccc' }}>
                      <button
                        className='action-btn btn-edit'
                        onClick={() => setEditForm(caste)}
                      >
                        Edit
                      </button>
                      <button
                        className='action-btn btn-delete'
                        onClick={() => {
                          setDeleteEntryNo({ entryNo: caste.EntryNo, flag: caste.Flag });
                          setOpenConfirmation(true);
                        }}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      {<Dialog
        open={openConfirmation}
        onClose={() => setOpenConfirmation(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"CONFIRM DELETE"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to DELETE this Entry ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmation(false)} color="inherit">
            Cancel
          </Button>
          <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>}
    </div>
  );
}
export default PackingEntry;